<template>
  <div class="list-brands">
    <div class="row">
      <div class="col-md-12">
        <KTCodePreview v-bind:title="'Danh sách thương hiệu'">
          <!-- Toolbar -->
          <template v-slot:toolbar>
            <div class="row">
              <BaseButton
                variant="primary"
                size="sm"
                class="font-weight-bolder"
                icon="flaticon2-add-1"
                @click="addRow"
              >
                Tạo mới
              </BaseButton>
            </div>
          </template>

          <!-- Content -->
          <template v-slot:preview>
            <!-- Search Bar -->
            <div class="col-md-12 mb-5" v-if="!isLoading">
              <b-form>
                <div class="row">
                  <BaseSearchBar
                    v-model="search"
                    size="sm"
                    placeholder="Tìm kiếm"
                    class="col-md-3"
                    @input="onInputChange"
                    @keyup.enter="fetchBrands"
                  />
                  <div class="col-md-3" style="padding: 0">
                    <div class="d-flex justify-content-end"></div>
                  </div>
                </div>
              </b-form>
            </div>

            <!-- Table -->
            <BaseBrandTable
              v-if="!isLoading"
              :brands="brands"
              :parent-edit="parentEdit"
              :current-page="currentPage"
              :items-per-page="itemsPerPage"
              @update="updateBrand"
              @delete="deleteBrand"
              @add="addNewBrand"
              @cancel-add="cancelAdd"
            />

            <!-- Pagination & Summary -->
            <b-row
              v-if="!isLoading"
              class="justify-content-between pagination-row"
            >
              <BaseSummary :total="totalItems" label="Tổng số thương hiệu" />

              <BPaginationNavCustom
                :number-of-pages="totalPages"
                :current-page="currentPage"
                :total-page="totalPages"
                @page-change="fetchBrands"
              ></BPaginationNavCustom>
            </b-row>

            <vcl-table
              v-if="isLoading"
              :speed="5"
              :animate="true"
              :columns="11"
            ></vcl-table>
          </template>
        </KTCodePreview>
      </div>
    </div>
  </div>
</template>

<script>
import debounce from 'debounce';
import { VclTable } from 'vue-content-loading';
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import { TIME_TRIGGER } from '@/utils/constants';
import useSearch from '@/composables/useSearch';

import BaseButton from '@/view/components/base/BaseButton.vue';
import BaseSearchBar from '@/view/components/base/BaseSearchBar.vue';
import BaseBrandTable from '@/view/pages/brand/components/BrandTable.vue';
import BaseSummary from '@/view/components/base/BaseSummary.vue';
import BPaginationNavCustom from '@/view/base/bootstrap/BPaginationNavCustom.vue';
import { BrandStoreMixin } from './mixins/BrandStoreMixin';

export default {
  mixins: [BrandStoreMixin],
  name: 'ListBrand',

  components: {
    KTCodePreview,
    BaseButton,
    BaseSearchBar,
    BaseBrandTable,
    BPaginationNavCustom,
    BaseSummary,
    VclTable,
  },

  data() {
    return {
      edit: false,
    };
  },

  created() {
    const { updateSearch } = useSearch.create(
      (searchValue) => this.handleSearch(searchValue),
      TIME_TRIGGER,
    );

    this.searchHandler = updateSearch;

    this.fetchBrands(this.$route.query.page || 1, '');
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Thương hiệu', route: '/brands' },
      { title: 'Danh sách thương hiệu' },
    ]);
  },

  methods: {
    addRow() {
      const hasEmptyRow = this.brands.some((brand) => brand.id === '');
      if (hasEmptyRow) {
        return;
      }

      this.edit = true;
      this.parentEdit = this.edit;
      this.$emit('parentEdit', this.parentEdit);

      this.brands.unshift({
        count: '',
        id: '',
        name: '',
      });
    },

    cancelAdd() {
      this.brands.shift();
    },
    debounceInput: debounce(function() {
      this.fetchBrands();
    }, TIME_TRIGGER),

    handleSearch(value) {
      this.search = value;
      this.fetchBrands();
    },

    onInputChange(text) {
      this.searchHandler(text);
    },
  },
};
</script>

<style lang="scss" scoped>
.list-brands {
  :deep(.icon) {
    &:hover {
      background-color: #90c6fc;
    }
  }

  :deep(.table) {
    table-layout: fixed;
  }

  :deep(.page-item.disabled) {
    cursor: not-allowed;
    &.bv-d-xs-down-none {
      .page-link {
        margin: 0.35rem 0.25rem;
        text-align: center;
      }
    }
  }

  .pagination-row {
    padding: 0 0.75rem;
  }
}
</style>
